module.exports = __webpack_public_path__ + "static/img/3_g_tick.0e157ced.png";